export default __webpack_public_path__ + "static/media/magicyard.1cbf9200.webp";